<template>
<div class="container" :style="add_style" v-if="$route.path==='/login'">
	<router-view/>
</div>
  <div v-else id="app" class="container" :style="add_style">
    <div class="container" :style="add_style">
        <the-side></the-side>
      <div class="main">
        <div class="main-content gim-card gim-background-img">
        <router-view></router-view>
        </div>
      </div>
    </div>
    <div :class="'detail-total detail-total-'+class_type" v-show="showDetail">
      <div class="detail-modal" :style="add_detail_style" @click="showDetail=false"></div>
      <div class="detail-content">
        <offer-detail :id="detail_id" v-if="detailType==='offer'"></offer-detail>
        <adv-detail :id="detail_id" v-if="detailType==='adv'"></adv-detail>
        <channel-detail :id="detail_id" v-if="detailType==='channel'"></channel-detail>
        <user-detail :id="detail_id" v-if="detailType==='user'"></user-detail>
				<mmp-offer-detail :id="detail_id" v-if="detailType==='mmp_offer'"></mmp-offer-detail>
      </div>
    </div>
  </div>
</template>


<script>
import TheSide from './views/Side'
import OfferDetail  from './views/OfferDetail'
import AdvDetail from './views/AdvDetail'
import ChannelDetail from './views/ChannelDetail'
import UserDetail from './views/UserDetail'
import mmpOfferDetail from './views/mmpOfferDetail'
import Login from './views/Login'
export default {
	data() {
		const reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
		const user_agent = window.navigator.userAgent;
		let class_type;
		if (reg.test(user_agent)) {
			class_type = 'phone';
		} else {
			class_type = 'web';
		}
		this.$cache.browse_model = class_type;
		return {
			class_type: class_type,
			add_style: '',
			add_detail_style: '',
			isCollapse: false,
			showDetail: false,
			show_channel_detail: false,
			detailType: '',
			detail_id: '',
			detail_offer_id: 0,
			detail_adv_id: 0,
			detail_channel_id: 0,
		};
	},
	methods: {
	},
	provide: function(){
		const self = this;
		return {
			rootGetDetail(row_id,type) {
				self.detailType = type;
				self.showDetail = true;
				self.detail_id = row_id;
			}
		}
	},
	watch: {
		$route(to, from) {
			this.$cache.to_path = from;
			document.title = to.name;
		}
	},
	mounted() {
		document.title = this.$route.name;
		if (this.class_type === 'phone') {
			let wh_percent;
			const dbcW = document.body.clientWidth;
			const dbcH = document.body.clientHeight;
			if (dbcW > dbcH) {
				wh_percent = dbcW / dbcH;
			} else {
				wh_percent = dbcH / dbcW;
			}
			const w = (1100 * wh_percent).toFixed(0);
			this.add_style = `height: 1100px; width: ${w}px;`;
			// - detailWidth
			this.add_detail_style = `width: ${w - 600}px;`;
		}
		
	},
	components:{
		'the-side':TheSide,
		'login-in':Login,
		'offer-detail':OfferDetail,
		'adv-detail':AdvDetail,
		'channel-detail':ChannelDetail,
		'user-detail':UserDetail,
		'mmp-offer-detail':mmpOfferDetail,
	}
};
</script>

<style scoped>
.main {
	display: flex;
	padding: 10px 10px 10px 10px;
	width: 100%;
	background: #f3f3fe;
	overflow: hidden;
}
.main-content {
	display: flex;
	flex-grow: 100;
	width: 98%;
	background: white;
	background-color: white;
	padding: 1%;
}
.detail-total{
  display:flex;
  flex-direction: row;
  position: absolute;
  z-index:100;
}
.detail-total-web{
  height: 100%;
	width: 100%;
}
.detail-total-phone{
	height: 1100px;
}
.detail-modal{
	flex-grow: 100;
  height: 100%;
}
.detail-content{
  width:600px;
  height: 100%;
  overflow: scroll;
  background-color: white;
  box-shadow: -5px -3px 5px rgba(140,140,140,0.6);
}
.gim-background-img {
	/* background: url(./assets/longmao_background.png) no-repeat 90% 80%; */
	background-color: #fff;
}
</style>
